export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = `a52c19ab-1298-40df-931d-96dd2f4d063b`;
export const MODAL_CLOSE_SEC = 2.5;
